module.exports = __webpack_public_path__ + "img/scale of pay 2024crop.a40e37f1.jpg";